/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_4Inputs */

const en_signup_feature_starter_4 = /** @type {(inputs: Signup_Feature_Starter_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic subtitle file export**`)
};

const fr_signup_feature_starter_4 = /** @type {(inputs: Signup_Feature_Starter_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation de fichiers de sous-titres de base**`)
};

const de_signup_feature_starter_4 = /** @type {(inputs: Signup_Feature_Starter_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportieren von Standard-Untertiteldateien**`)
};

const it_signup_feature_starter_4 = /** @type {(inputs: Signup_Feature_Starter_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione di file di sottotitoli di base**`)
};

const ru_signup_feature_starter_4 = /** @type {(inputs: Signup_Feature_Starter_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базовый экспорт файла субтитров**`)
};

const es_signup_feature_starter_4 = /** @type {(inputs: Signup_Feature_Starter_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación básica de archivos de subtítulos**`)
};

const zh_cn2_signup_feature_starter_4 = /** @type {(inputs: Signup_Feature_Starter_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本字幕文件导出**`)
};

const ja_signup_feature_starter_4 = /** @type {(inputs: Signup_Feature_Starter_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本的な字幕ファイルのエクスポート**`)
};

const hi_signup_feature_starter_4 = /** @type {(inputs: Signup_Feature_Starter_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बुनियादी उपशीर्षक फ़ाइल निर्यात**`)
};

const pt_pt2_signup_feature_starter_4 = /** @type {(inputs: Signup_Feature_Starter_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação básica de arquivos de legenda**`)
};

/**
* | output |
* | --- |
* | "Basic subtitle file export**" |
*
* @param {Signup_Feature_Starter_4Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_4 = /** @type {((inputs?: Signup_Feature_Starter_4Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_4Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_starter_4(inputs)
	if (locale === "de") return de_signup_feature_starter_4(inputs)
	if (locale === "it") return it_signup_feature_starter_4(inputs)
	if (locale === "ru") return ru_signup_feature_starter_4(inputs)
	if (locale === "es") return es_signup_feature_starter_4(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_starter_4(inputs)
	if (locale === "ja") return ja_signup_feature_starter_4(inputs)
	if (locale === "hi") return hi_signup_feature_starter_4(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_starter_4(inputs)
	return en_signup_feature_starter_4(inputs)
});